import * as Function from "../Function";
import * as Error from "../Error";
import { array, option } from "fp-ts/lib";

export const inOrder = (...validators: Array<Function.TValidationFunction>): Function.TValidationFunction =>
    (value: unknown): option.Option<Error.TValidationError> =>
        array.reduce<Function.TValidationFunction, option.Option<Error.TValidationError>>(option.none, (validationResult, f) =>
            option.isNone(validationResult) ? f(value) : validationResult
        )(validators);
